<!--
单页面示例：字段较多、两列布局；
-->
<template>
<div width="100%" style="border: 0px;" height="100%" >
  <form id="myForm" method="post" target="myFrame"  :action="'//'+util.apiBasePath+'/jpcp/peGraduation/printCertificate'">
    <input type="hidden" name="studentId" :value="studentId" />
    <input type="hidden" name="projectId" :value="projectId" />
 </form>
<iframe name="myFrame" width="100%"  height="800px"  style="border: 0px;" ></iframe>

</div>
</template>
<script>
  import ScrollRightFrame from '../../../../components/scroll-right-frame'
  import util from '../../../../libs/util'
  export default {
    name: 'printCertificate',
    components: {ScrollRightFrame},
    data() {
      return {
        util:util
      }
    },
    watch: {
      '$route':function(to, from) {
      }
    },
    computed:{
      studentId:function(){
          return this.$route.query.studentId;
      },
      projectId :function(){
        return this.$route.query.id;
      }

    },
    mounted(){
      const _than =this;
    window.goback =function(){
       util.routerBack(_than,"/");
    }
    window.tip =function(msg){
        _than.$notify.success({title: '成功', message: msg});
    },
    window.warning =function(msg){
        _than.$notify.warning({title: '提示', message: msg});
    },
    this.submit();
    },
    methods: {
      submit:function(){      
          document.getElementById("myForm").submit();
      }
    }
  }
</script>
<style lang="scss">
  
</style>


// WEBPACK FOOTER //
// src/custom/components/jpcp/project/graduation-printCertificate.vue